
// https://stackoverflow.com/questions/56462796/how-to-generate-aws-exports-js-with-existing-user-pool-in-aws-cognito
// https://docs.amplify.aws/gen1/javascript/tools/libraries/configure-categories/

import { EpdSmartApiLoad } from "./Library";

function setConfig() {

    const dev = {

        Environment: '',

        Auth: {

            userPoolId: 'eu-west-2_ZTR4bbxZN', 
            userPoolWebClientId: '6g6stmbin0tk4rdmdotc29id9l', 
            oauth: {
                domain: 'auth.dev.admin.easypeasydigital.com',
                scopes: ['openid', 'aws.cognito.signin.user.admin', 'epdstatus/upstate.read'],
                redirectSignIn: 'http://localhost:3000/',
                redirectSignOut: 'http://localhost:3000/',
                responseType: 'code',
            },
        
            API: {
                endpoints: [
                    {
                        name: "API-Gateway",
                        endpoint: "https://17q9vlpfhf.execute-api.eu-west-2.amazonaws.com",
                    }
                ]
            },
        },
        ApiGateway: {

            apiName: 'API-Gateway',
            apiPath: '/api/', 

            apiInit: {
                headers: {
                    "Access-Control-Allow-Headers": "*",
                    "Access-Control-Allow-Methods": "*",
                    "Access-Control-Allow-Origin": "*"
                }
            }
        }
    }




    const stage = {

        Environment: '',

        Auth: {
            userPoolId: 'eu-west-2_ZTR4bbxZN',
            userPoolWebClientId: '6tb02ku99s14nnli2h3u7gc28n',
            oauth: {
                domain: 'auth.dev.admin.easypeasydigital.com',
                scopes: ['openid', 'aws.cognito.signin.user.admin', 'epdstatus/upstate.read'],
                redirectSignIn: 'https://dev.admin.easypeasydigital.com',
                redirectSignOut: 'https://dev.admin.easypeasydigital.com',
                responseType: 'code',
            },

            API: {
                endpoints: [
                    {
                        name: "API-Gateway",
                        endpoint: "https://dev.admin.easypeasydigital.com",
                    }
                ]
            },
        },
        ApiGateway: {

            apiName: 'API-Gateway',
            apiPath: '/api/',

            apiInit: {
                headers: {
                    "Access-Control-Allow-Headers": "*",
                    "Access-Control-Allow-Methods": "*",
                    "Access-Control-Allow-Origin": "*"
                }
            }
        }
    };

//            domain: 'epdstatus.auth.eu-west-2.amazoncognito.com',
// name: "epdstatus-API-Gateway",
  //   endpoint: "https://admin.easypeasydigital.com",


    const prod = {
        
        Environment: '',

        Auth: {
            region: 'eu-west-2',
            userPoolId: 'eu-west-2_quwRLXs2J', 
            userPoolWebClientId: '76mgc1f6uvh1oha0iatqiq73tc', 
            oauth: { 
                domain: 'auth.admin.easypeasydigital.com',  
                scopes: ['openid', 'aws.cognito.signin.user.admin', 'epdstatus/upstate.read'],
                redirectSignIn: 'https://admin.easypeasydigital.com',
                redirectSignOut: 'https://admin.easypeasydigital.com',
                responseType: 'code',
            },

            API: {
                endpoints: [
                    {       
                        name:"API-Gateway", 
                        endpoint: "https://admin.easypeasydigital.com",
                    }
                ]
            },
        },
        ApiGateway: {

            apiName: 'API-Gateway',
            apiPath: '/api/', // the (prod) environment for api gateway is provided by cloudfront

            apiInit: {
                headers: {
                    "Access-Control-Allow-Headers": "*",
                    "Access-Control-Allow-Methods": "*",
                    "Access-Control-Allow-Origin": "*"
                }
            }
        }
    };



    const targetStage = (process.env.REACT_APP_STAGE || 'dev').trim().toLowerCase();

    switch (targetStage) {
        case 'prod':
            return (prod);

        case 'stage':
            return (stage);

        case 'dev':
        default:
            return (dev);
    }
}


//const config = (process.env.REACT_APP_STAGE === 'prod') ? prod : dev;


const config = setConfig();

const awsconfig = config.Auth;
const environment = config.Environment + ' 3v0';
const apiGateway = config.ApiGateway;




export { awsconfig, environment, apiGateway };
